import React from 'react';
import styles from './PwaNotificationReminder.module.css';

export const PwaNotificationReminderStatusKey = 'PwaNotificationReminderStatusKey';
export const PwaNotificationReminderHiddenStatus = 'pwanotificationhidden';

import { platformHelper } from '../../common/helpers/platformHelper';
import { CloseIconSvg } from './CloseIconSvg';
import { PwaIcon } from './PwaIcon';
import { PwaText } from './PwaText';
import { useRouter } from 'next/router';
import useMediaQuery from '@mui/material/useMediaQuery';
import { KnownBreakpoints } from '../../common/constants';
import { useTheme } from '@mui/material/styles';

const skipURLs = ['/pwa-notifiction-instruction'];

export type PwaNotificationReminderProps = {
    iosOnly?: boolean;
};

// eslint-disable-next-line react/display-name
export const PwaNotificationReminder = React.memo((props: PwaNotificationReminderProps) => {
    const {
        iosOnly = true,
    } = props;

    const theme = useTheme();

    //console.log('Notification', (Notification || {}).permission);
    const [localStorageStatus, setLocalStorageStatus] = React.useState<string | null>(null);
    const [sessionStorageStatus, setSessionStorageStatus] = React.useState<string | null>(null);
    const [notificationsEnabled, setNotificationsEnabled] = React.useState<boolean | null>(null);
    const [pwaInstalled, setPwaInstalled] = React.useState<boolean | null>(null);
    const [isIos, setIsIos] = React.useState<boolean | null>(null);

    const isDesktop = useMediaQuery(
        theme.breakpoints.up(KnownBreakpoints.tablet),
    );



    React.useEffect(() => {
        setSessionStorageStatus(sessionStorage.getItem(PwaNotificationReminderStatusKey));
        setLocalStorageStatus(localStorage.getItem(PwaNotificationReminderStatusKey));
        const permission = (window?.Notification || {}).permission;
        setNotificationsEnabled('granted' == permission);
        setPwaInstalled(platformHelper.isStandalone);
        setIsIos(platformHelper.isIos);
    }, []);

    const router = useRouter();


    const isVisible = React.useMemo(() => {
        if(skipURLs.includes(router.route)){
            return false;
        }
        if (pwaInstalled && notificationsEnabled) {
            return false;
        }
        if (!isDesktop && (iosOnly && !isIos)) {
            return false;
        }
        return localStorageStatus !== PwaNotificationReminderHiddenStatus
            &&
            sessionStorageStatus !== PwaNotificationReminderHiddenStatus;
    }, [sessionStorageStatus, localStorageStatus, iosOnly, pwaInstalled, router.route]);

    const closePopup = React.useCallback(() => {
        setSessionStorageStatus(PwaNotificationReminderHiddenStatus);
        sessionStorage.setItem(PwaNotificationReminderStatusKey, PwaNotificationReminderHiddenStatus);
    }, [sessionStorageStatus]);

    const openInstructions = React.useCallback(() => {
        setLocalStorageStatus(PwaNotificationReminderHiddenStatus);
        router.push('/pwa-notifiction-instruction');
    }, [localStorageStatus]);

    //console.log("isVisible", isVisible, "pwaInstalled", pwaInstalled, );

    if (!isVisible) {
        return null;
    }

    return <div id={ styles['pwa-notification-reminder'] }>
        <div id={ styles['pwa-notification-layout'] }>
            <div id={ styles['pwa-notification-container'] }>
                <div id={styles['pwa-notification-close-button']} onClick={ closePopup }>
                    <CloseIconSvg />
                </div>
                <div id={ styles['pwa-notification-content'] }>
                    <div id={ styles['pwa-notification-icon'] }>
                        <PwaIcon notificationEnabled={notificationsEnabled} pwaInstalled={pwaInstalled} />
                    </div>
                    <div id={ styles['pwa-notification-text'] }>
                        <PwaText notificationEnabled={notificationsEnabled} pwaInstalled={pwaInstalled} />
                    </div>
                    <button id={ styles['pwa-button'] } onClick={ openInstructions }>
                        Read instructions
                    </button>
                </div>
            </div>
        </div>
    </div>;
});
